$(document).ready(function() {
  $(".fade-out")
    .delay(8000)
    .fadeOut(500);
});
